import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import E2EApp from './e2e-app/App.tsx';
import './index.css';
import RecorderApp from './recording-app/App.tsx';
import SampleAppSDK from './sample-app-sdk/App.tsx';

const appName = import.meta.env.VITE_APP;

if (appName === 'sample-app-sdk') {
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <SampleAppSDK />
    </StrictMode>,
  );
} else if (appName === 'recorder') {
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <RecorderApp />
    </StrictMode>,
  );
} else if (appName === 'e2e') {
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <E2EApp />
    </StrictMode>,
  );
} else {
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <SampleAppSDK />
    </StrictMode>,
  );
}
